const ThemeColors = {
  headerAccent: "#743276",
  headerBackground: "#FFFFFF",
  headerButton: "#64C2FC",
  headerTextColor: "#21394F",
  navigationButtons: "#6DC2FC",
  progressBar: "#EEEEEE",
  tableHeadersTextColor: "#FFFFFF",
};

const chartColors = {
  chartAxisGrey100: "rgba(217, 217, 217, 1)",
  chartDarkBlue100: "rgba(33, 57, 79, 1)",
  chartDarkBlue70: "rgba(33, 57, 79, 0.7)",
  chartFilteredGray0: "rgba(102, 112, 128, 0)",
  chartFilteredGray10: "rgba(102, 112, 128, 0.1)",
  chartFilteredGray100: "rgba(102, 112, 128, 1)",
  chartFilteredGray30: "rgba(102, 112, 128, 0.3)",
  chartFilteredGray70: "rgba(102, 112, 128, 0.7)",
  chartGreen100: "rgba(32, 183, 134, 1)",
  chartGreen70: "rgba(32, 183, 134, 0.7)",
  chartLightBlue10: "rgba(99, 194, 255, 0.1)",
  chartLightBlue100: "rgba(99, 194, 255, 1)",
  chartLightBlue20: "rgba(99, 194, 255, 0.2)",
  chartLightBlue60: "rgba(99, 194, 255, 0.6)",
  chartLightBlue70: "rgba(99, 194, 255, 0.7)",
  chartLightGrey100: "rgba(207, 216, 220, 1)",
  chartLightGrey70: "rgba(207, 216, 220, 0.7)",
  chartLightGreyHighlight50: "rgba(245, 245, 245, 0.5)",
};

export default {
  assessmentNotPassed: "#f96b07",
  black: "#000000",
  blue: "#648DC7",
  buttonBlue: "#64C2FC",
  buttonDarkBlue: "#4e9dc2",
  chartblue: "#5591ce",
  chartdarkblue: "#5b5bff",
  chartgreen: "#75e0a0",
  chartgrey: "#a0a0a0",
  chartlightblue: "#63C2FF",
  chartlightgreen: "#00e272",
  chartorange: "#ff9e23",
  chartred: "#ffa0a0",
  darkblue: "#21394F",
  darkgreen: "#3ebf96",
  darkgrey: "#555555",
  darkgrey1: "#646464",
  darkgrey2: "#838585",
  darkgrey3: "#919191",
  darkgrey4: "#767676",
  darkred: "#aa0000",
  defaultTheme: "#743276",
  filtergrey: "#E7E9FD",
  green: "#00ff00",
  greenSuccess: "#20B786",
  grey: "#888888",
  highlightLightBlue: "#e2eaf1",
  highlightLightGrey: "#e0e0e0",
  lightGrayishBlue: "#f1f3f4",
  lightblue: "#f0f8ff",
  lightgrey: "#EEEEEE",
  lightgrey2: "#dddddd",
  lightgrey3: "#f6f6f6",
  lightgrey4: "#9da0ac",
  lightsilver: "#c4c4c4",
  lightyellow: "#ffee6e",
  menuBlueDark: "#20394f",
  menuBlueLight: "#64c2ff",
  menuBlueSolidDark: "#111e27",
  menuGreyBorder: "#475868",
  orangeDark: "#d15954",
  orangeWarning: "#F9A23B",
  red: "#f00",
  redTableHeader: "#F04D46",
  selected: "#000aaa",
  teal: "#40444D",
  textDarkBlue: "#41454e",
  timeSpentStroke: "#63c2ff",
  white: "#FFFFFF",
  yellow: "#FFFFC0",
  ...ThemeColors,
  ...chartColors,
};
